class CollectionCustomFilters extends HTMLElement {
  constructor() {
    super();
    this.DEBUG = false;

    this.collectionCustomFilters = null;
    this.filterButtons = null;
    this.productListItems = null;
    this.noProductsSection = null;
  }

  connectedCallback() {
    this.log("Component connected");
    this.init();
  }

  init() {
    this.log("Initializing...");
    this.cacheElements();
  }

  cacheElements() {
    this.log("Caching elements");

    this.collectionCustomFilters = this.querySelector(
      "#collection-custom-filters"
    );
    this.log({ collectionCustomFilters: this.collectionCustomFilters });
    if (!this.collectionCustomFilters) return;

    this.filterButtons =
      this.collectionCustomFilters.querySelectorAll("button");
    this.log({ filterButtons: this.filterButtons });
    if (!this.filterButtons) return;

    this.productListItems = document.querySelectorAll("li[data-tags]");
    this.log({ productListItems: this.productListItems });
    if (!this.productListItems) return;

    this.noProductsSection = document.getElementById("no-products-section");
    this.noProductsSection?.classList.add("hidden");

    for (const button of this.filterButtons)
      button.addEventListener("click", (e) => this.handleFilterButtonClick(e));
    this.deselectAllFilterButtons();

    this.initSwiper(this.collectionCustomFilters);

    // See if there is already a selected filter in url
    const filter = new URLSearchParams(window.location.search).get("f");
    this.log({ filter });
    if (!filter) return;

    const filterInput = this.collectionCustomFilters.querySelector(
      `[data-filter="${filter}"]`
    );
    this.log({ filterInput });
    if (!filterInput) return;
    filterInput.click();
  }

  initSwiper(swiperContainer) {
    if (swiperContainer.classList.contains("swiper-initialized")) return;

    swiperContainer.classList.add("swiper-initialized");

    const config = {
      slidesPerView: 3.5,
      spaceBetween: 0, // Spazio tra le slide
      scrollbar: {
        el: swiperContainer.querySelector(".swiper-scrollbar"),
        hide: false,
        draggable: true,
        dragSize: "auto",
      },
      preventClicks: false,
      breakpoints: {
        750: {
          slidesPerView: "auto",
        },
      },
    };

    function handleResize() {
      return;
      const hasMobileDisabled = swiperContainer.hasAttribute(
        "data-mobile-swiper-disabled"
      );
      if (hasMobileDisabled && 750 > window.innerWidth) swiper.disable();
      else swiper.enable();
    }

    let resizeTimeout;
    window.addEventListener("resize", () => {
      // Debounce to avoid too many recalculations
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(handleResize, 150);
    });

    const swiper = new Swiper(swiperContainer, config);

    handleResize();

    let canClick = true;

    swiperContainer.addEventListener("mouseenter", function () {
      if (!canClick) return;
      swiper.params.speed = 1;
      canClick = false;
      setTimeout(() => {
        swiper.params.speed = 300;
        canClick = true;
      }, 50);
    });

    swiperContainer.addEventListener("mouseleave", function () {
      swiper.params.speed = 1;
      /* Uncomment to enable scroll to first image on mouse leave */
      // swiper.slideToLoop(0);
    });
  }

  deselectAllFilterButtons() {
    this.log("Deselecting all filter buttons");
    for (const button of this.filterButtons) this.deselectFilterButton(button);
  }

  deselectFilterButton(button) {
    this.log("Deselecting filter button", { button });
    if (!button) return;

    button.setAttribute("aria-pressed", false);

    if (!this.productListItems) return;
    Array.from(this.productListItems).map((p) => p.classList.remove("hidden"));
  }

  deselectFilterButtonClick(e) {
    this.log("Deselecting filter button click");
    if (!this.productListItems) return;

    const button = e.currentTarget;
    this.log({ button });
    if (!button) return;

    const isPressed = button.getAttribute("aria-pressed") === "true";
    this.log({ isPressed });
    if (!isPressed) return;

    this.deselectFilterButton(button);
  }

  updateURL(filter) {
    this.log("Update URL", { filter });

    const url = new URL(window.location.href);
    if (filter) url.searchParams.set("f", filter);
    else url.searchParams.delete("f");
    window.history.replaceState({}, "", url.toString());
  }

  handleFilterButtonClick(e) {
    this.log("Handle filter button click");
    if (!this.productListItems) return;

    const button = e.currentTarget;
    this.log({ button });
    if (!button) return;

    this.updateURL();
    const isPressed = button.getAttribute("aria-pressed") === "true";
    this.log({ isPressed });

    this.noProductsSection?.classList.add("hidden");
    if (isPressed) return this.deselectFilterButtonClick(e);
    else this.deselectAllFilterButtons();

    button.setAttribute("aria-pressed", true);

    this.updateURL(button.dataset.filter);

    const buttonTags = JSON.parse(button.dataset.tags);
    this.log({ buttonTags });
    if (!buttonTags) return;

    let foundProducts = 0;
    for (const product of this.productListItems) {
      product.classList.add("hidden");

      if (!product) continue;

      const productTags = JSON.parse(product.dataset.tags);
      if (!productTags) continue;

      const hasMatchingTag = buttonTags.some((tag) =>
        productTags.includes(tag)
      );
      if (hasMatchingTag) {
        foundProducts++;
        product.classList.remove("hidden");
      }
    }

    this.log({ foundProducts });
    if (!foundProducts) this.noProductsSection?.classList.remove("hidden");
  }

  disconnectedCallback() {
    this.log("Component disconnected");

    for (const button of this.filterButtons)
      button.removeEventListener("click", (e) =>
        this.handleFilterButtonClick(e)
      );
  }

  error(message) {
    this.log(message, "error");
  }

  log(message, type = "info") {
    if (!this.DEBUG) return;

    const styles = {
      info: "color: #2196F3",
      error: "color: #f44336",
      success: "color: #4CAF50",
    };

    console.log(
      "%c[Collection Custom Filters]",
      styles[type] || styles.info,
      message
    );
  }
}

if (!customElements.get("collection-custom-filters"))
  customElements.define("collection-custom-filters", CollectionCustomFilters);
